// Generated by CoffeeScript 1.12.7

/**
Restricts the value of an input to numbers only.

@method restrictNumeric
@param {Event} event the event from a jQuery keypress
@return {Boolean} whether or not the value is numeric or not
@example
$("#input").keypress(restrictNumeric)
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/restrict_numeric',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.restrictNumeric = factory();
  }
})(this, function() {
  var restrictNumeric;
  return restrictNumeric = function(e) {
    var ref, ref1, val;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 0) {
      return true;
    }
    if ((37 <= (ref = e.which) && ref <= 40)) {
      return true;
    }
    if ((96 <= (ref1 = e.which) && ref1 <= 105)) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    val = String.fromCharCode(e.which);
    if (!/^\d+$/.test(val)) {
      return e.preventDefault();
    }
  };
});

